(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
function initSunluxy(root){
if(root.dataset.ready)return;root.dataset.ready='true';


root.querySelectorAll('[data-flip-gallery]').forEach(gallery=>{
const cards=Array.from(gallery.querySelectorAll('[data-flip-card]'));
const count=gallery.querySelector('[data-flip-count]');
const controls=gallery.querySelectorAll('[data-flip-step]');
const deck=gallery.querySelector('.sl-flip-deck');
if(!cards.length)return;
let current=0,startX=null,startY=null;
const show=index=>{
current=(index+cards.length)%cards.length;
cards.forEach((card,i)=>{card.dataset.depth=String((i-current+cards.length)%cards.length);card.setAttribute('aria-hidden',String(i!==current));});
count.textContent=(current+1)+' / '+cards.length;
};
controls.forEach(button=>{button.disabled=cards.length<2;button.addEventListener('click',()=>show(current+Number(button.dataset.flipStep)));});
gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1));}});
deck.addEventListener('pointerdown',e=>{if(e.button!==0)return;startX=e.clientX;startY=e.clientY;deck.setPointerCapture(e.pointerId);});
deck.addEventListener('pointerup',e=>{if(startX===null)return;const dx=e.clientX-startX,dy=e.clientY-startY;startX=null;startY=null;if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy))show(current+(dx<0?1:-1));});
deck.addEventListener('pointercancel',()=>{startX=null;startY=null;});
show(0);
});

const resultTrack=root.querySelector('[data-results-track]');
if(resultTrack){
const cards=Array.from(resultTrack.querySelectorAll('[data-result-card]'));
const previous=root.querySelector('[data-results-step="-1"]');
const next=root.querySelector('[data-results-step="1"]');
let current=0,startX=null,startScroll=0;
const sizeTail=()=>resultTrack.style.setProperty('--result-tail',Math.max(0,resultTrack.clientWidth-cards[0].offsetWidth+24)+'px');
sizeTail();
const offset=i=>cards[i].offsetLeft-cards[0].offsetLeft;
const update=()=>{let distance=Infinity;cards.forEach((card,i)=>{const d=Math.abs(offset(i)-resultTrack.scrollLeft);if(d<distance){distance=d;current=i;}});cards.forEach((card,i)=>card.classList.toggle('is-current',i===current));root.querySelector('[data-results-count]').textContent=(current+1)+' / '+cards.length;previous.disabled=current===0;next.disabled=current===cards.length-1;};
const go=step=>{const target=Math.max(0,Math.min(cards.length-1,current+step));resultTrack.scrollTo({left:offset(target),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});};
previous.addEventListener('click',()=>go(-1));next.addEventListener('click',()=>go(1));resultTrack.addEventListener('scroll',update,{passive:true});
resultTrack.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(e.key==='ArrowRight'?1:-1);}});
resultTrack.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;startX=e.clientX;startScroll=resultTrack.scrollLeft;resultTrack.setPointerCapture(e.pointerId);resultTrack.style.scrollSnapType='none';});
resultTrack.addEventListener('pointermove',e=>{if(startX!==null)resultTrack.scrollLeft=startScroll+startX-e.clientX;});
const release=()=>{if(startX===null)return;startX=null;resultTrack.style.scrollSnapType='';update();go(0);};
resultTrack.addEventListener('pointerup',release);resultTrack.addEventListener('pointercancel',release);
const sizeObserver=new ResizeObserver(()=>{sizeTail();update();});sizeObserver.observe(resultTrack);
const onUnload=e=>{if(e.target.contains(root)){sizeObserver.disconnect();document.removeEventListener('shopify:section:unload',onUnload);}};document.addEventListener('shopify:section:unload',onUnload);
update();
}


root.querySelectorAll('[data-compare-tab]').forEach(button=>button.addEventListener('click',()=>{
root.querySelectorAll('[data-compare-tab]').forEach(tab=>tab.setAttribute('aria-pressed',String(tab===button)));
root.querySelectorAll('[data-compare-case]').forEach(panel=>{panel.hidden=panel.dataset.compareCase!==button.dataset.compareTab;});
}));
root.querySelectorAll('.sl-compare-range').forEach(input=>input.addEventListener('input',()=>input.closest('.sl-compare-frame').style.setProperty('--reveal',input.value+'%')));

const img=root.querySelector('.sl-hero-image');
const hero=root.querySelector('.sl-hero');
const scenes=Array.from(root.querySelectorAll('[data-scene]'));
const reduce=matchMedia('(prefers-reduced-motion:reduce)');
const toggle=root.querySelector('[data-hero-toggle]');
let index=0,autoplay=!reduce.matches,hovered=false,focused=false,inView=true,timer=null,ticket=0;
const animate=(node,frames,options)=>{if(!reduce.matches&&node?.animate)node.animate(frames,options);};
const refresh=()=>{
clearInterval(timer);timer=null;
const running=autoplay&&!hovered&&!focused&&inView&&!document.hidden;
root.classList.toggle('sl-motion-on',autoplay&&!reduce.matches);
root.classList.toggle('sl-motion-held',!running);
toggle.textContent=autoplay?toggle.dataset.pause:toggle.dataset.play;
if(running&&scenes.length>1)timer=setInterval(()=>select((index+1)%scenes.length),8000);
};
async function select(next,manual=false){
if(!scenes.length)return;
const button=scenes[(next+scenes.length)%scenes.length],version=++ticket;
if(manual)autoplay=false;
const source=button.dataset.image;
if(img&&source){const preload=new Image();preload.src=source;try{await preload.decode();}catch{refresh();return;}}
if(version!==ticket||!root.isConnected)return;
index=scenes.indexOf(button);
scenes.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
root.querySelector('[data-scene-title]').textContent=button.dataset.title;
root.querySelector('[data-scene-text]').textContent=button.dataset.text;
root.querySelectorAll('[data-hero-link]').forEach(a=>a.href=button.dataset.url);
root.querySelector('[data-hero-product]').textContent=button.dataset.productTitle;
root.querySelector('[data-hero-price]').textContent=button.dataset.price;
root.querySelector('.sl-text-link').hidden=button.dataset.bodyVideo!=='true';
root.querySelector('[data-hero-count]').textContent=(index+1)+' / '+scenes.length;
if(img&&source){img.removeAttribute('srcset');img.src=source;img.alt=button.dataset.productTitle+' — '+button.dataset.title;img.style.objectPosition=button.dataset.position+' center';animate(img,[{opacity:.15},{opacity:1}],{duration:650,easing:'ease-out'});}
[root.querySelector('[data-scene-title]'),root.querySelector('[data-scene-text]'),root.querySelector('.sl-product-note')].forEach(node=>animate(node,[{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:500,easing:'ease-out'}));
refresh();
}
scenes.forEach((button,i)=>{button.addEventListener('click',()=>select(i,true));button.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();const next=(i+(event.key==='ArrowRight'?1:-1)+scenes.length)%scenes.length;scenes[next].focus();select(next,true);});});
root.querySelector('[data-hero-prev]').addEventListener('click',()=>select(index-1,true));
root.querySelector('[data-hero-next]').addEventListener('click',()=>select(index+1,true));
toggle.addEventListener('click',()=>{autoplay=!autoplay;refresh();});
hero.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;refresh();}});
hero.addEventListener('pointerleave',()=>{hovered=false;refresh();});
hero.addEventListener('focusin',()=>{focused=true;refresh();});
hero.addEventListener('focusout',event=>{focused=hero.contains(event.relatedTarget);refresh();});
let touch=null;const media=root.querySelector('.sl-hero-media');
media.addEventListener('touchstart',event=>{touch=event.touches[0];},{passive:true});
media.addEventListener('touchend',event=>{if(!touch)return;const end=event.changedTouches[0],dx=end.clientX-touch.clientX,dy=end.clientY-touch.clientY;if(Math.abs(dx)>65&&Math.abs(dx)>Math.abs(dy)*1.5)select(index+(dx<0?1:-1),true);touch=null;},{passive:true});
const heroObserver=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;refresh();},{threshold:.25});heroObserver.observe(hero);
const visibility=()=>refresh();document.addEventListener('visibilitychange',visibility);
reduce.addEventListener('change',()=>{if(reduce.matches)autoplay=false;refresh();});
const reveal=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;animate(entry.target,[{opacity:0,transform:'translateY(24px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'ease-out'});reveal.unobserve(entry.target);}),{threshold:.12});
root.querySelectorAll('.sl-section-head,.sl-collection,.sl-story-copy,.sl-video-card,.sl-article').forEach(node=>reveal.observe(node));
const videoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting&&entry.target.dataset.preview==='true')entry.target.pause();}),{threshold:.2});
root.querySelectorAll('[data-video-preview]').forEach(button=>{const video=button.closest('.sl-video-card').querySelector('video');videoObserver.observe(video);button.addEventListener('click',async()=>{if(!video.paused){video.pause();return;}video.dataset.preview='true';video.muted=true;video.loop=true;try{await video.play();}catch{video.dataset.preview='false';button.setAttribute('aria-pressed','false');}});video.addEventListener('play',()=>button.setAttribute('aria-pressed','true'));video.addEventListener('pause',()=>{button.setAttribute('aria-pressed','false');video.loop=false;video.dataset.preview='false';});});
select(0);
root.slCleanup=()=>{clearInterval(timer);heroObserver.disconnect();reveal.disconnect();videoObserver.disconnect();document.removeEventListener('visibilitychange',visibility);root.querySelectorAll('video').forEach(v=>v.pause());};
const track=root.querySelector('[data-product-track]');
const update=()=>{if(!track)return;root.querySelector('[data-scroll="-1"]').disabled=track.scrollLeft<2;root.querySelector('[data-scroll="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
root.querySelectorAll('[data-scroll]').forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.scroll)*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})));
track?.addEventListener('scroll',update,{passive:true});if(track)new ResizeObserver(update).observe(track);update();
root.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>root.querySelectorAll('video').forEach(v=>{if(v!==video)v.pause();})));
}
document.querySelectorAll('.sl-home').forEach(initSunluxy);
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.sl-home').forEach(root=>root.slCleanup?.()));
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.sl-home').forEach(initSunluxy));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunluxy-dermaplaning-story"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('sunluxy-dermaplaning')){
    customElements.define('sunluxy-dermaplaning',class extends HTMLElement{
      connectedCallback(){
        if(this.ready)return;
        this.ready=true;
        this.controller=new AbortController();
        const signal=this.controller.signal;
        const tabs=Array.from(this.querySelectorAll('[role="tab"]'));
        const panels=Array.from(this.querySelectorAll('[role="tabpanel"]'));
        const activate=(index,focus=false)=>{
          tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
          if(focus)tabs[index].focus();
        };
        tabs.forEach((tab,index)=>{
          tab.addEventListener('click',()=>activate(index),{signal});
          tab.addEventListener('keydown',event=>{
            let next=index;
            if(event.key==='ArrowRight')next=(index+1)%tabs.length;
            else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;
            else if(event.key==='Home')next=0;
            else if(event.key==='End')next=tabs.length-1;
            else return;
            event.preventDefault();activate(next,true);
          },{signal});
        });
        const sticky=this.querySelector('.slx-dp__sticky');
        const purchase=document.querySelector('product-info [id^="ProductSubmitButton-"]');
        if(sticky&&purchase&&'IntersectionObserver' in window){
          this.observer=new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>0;},{threshold:0});
          this.observer.observe(purchase);
        }
        this.querySelectorAll('a[href="#MainContent"]').forEach(link=>link.addEventListener('click',event=>{
          const target=document.querySelector('#MainContent');
          if(!target)return;
          event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
          const heading=target.querySelector('h1');
          if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});}
        },{signal}));
      }
      disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.ready=false;}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
